{
    "productImageZoomTrigger":{
       "expand":""
    },
    "productImageZoomDialog":{
       "close":"Abbruch"
    }
 }